import * as styledComponents from 'styled-components';
import { ThemedStyledComponentsModule } from 'styled-components';

const {
    default: styled,
    css,
    injectGlobal,
    ThemeProvider,
    withTheme,
} = styledComponents as ThemedStyledComponentsModule<any>;

export {
    css,
    injectGlobal,
    ThemeProvider,
    withTheme
};

export default styled;



// WEBPACK FOOTER //
// ./src/theme/index.ts